// extracted by mini-css-extract-plugin
export var cancelButton = "_o5-5";
export var content = "_o5-3";
export var createButton = "_o5-6";
export var drawerContainer = "_o5-0";
export var footer = "_o5-2";
export var header = "_o5-1";
export var orderFormColumn = "_o5-4";